<section class="dialog-section">
  <div class="dialog-container">
    <div class="dialog-card">
      <!-- Content -->
      <div class="dialog-content">
        <p class="dialog-description" *ngFor="let error of errors">
          {{ "page.order.addToCartError." + error.code | translate: { names: error.items | groupedErrorNames } }}
        </p>
      </div>

      <!-- Actions -->
      <div class="dialog-actions">
        <button *ngIf="required" class="primary-button" (click)="addDna()" [disabled]="isAddingToCart">
          {{ "button.addDnaAndRetry" | translate }}
        </button>

        <button class="secondary-button" (click)="close()">
          {{ "button.close" | translate }}
        </button>
      </div>
    </div>
  </div>
</section>
